module.exports = __webpack_public_path__ + "media/thirdSection/3-76b97c73.png";